/* unplugin-vue-components disabled */import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ultra-editor"
};
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import ultraUploadFile from '../../utils/ultraUpload.js';
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    customToolbar: {
      type: Array,
      default: () => []
    },
    editorHeight: {
      type: String,
      default: '200px'
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    _useCssVars(_ctx => ({
      "069a30eb": props.editorHeight
    }));
    let quill = null;
    const uEditor = ref();
    // const _content = ref<any>('');
    const toolbarOptions = [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{
      'header': 1
    }, {
      'header': 2
    }], [{
      'list': 'ordered'
    }, {
      'list': 'bullet'
    }], [{
      'script': 'sub'
    }, {
      'script': 'super'
    }], [{
      'indent': '-1'
    }, {
      'indent': '+1'
    }], [{
      'direction': 'rtl'
    }], [{
      'size': ['small', false, 'large', 'huge']
    }], [{
      'header': [1, 2, 3, 4, 5, 6, false]
    }], [{
      'color': []
    }, {
      'background': []
    }], [{
      'font': []
    }], [{
      'align': []
    }], ['clean'], ['link', 'image']];
    const handleContent = () => {
      const content = getContent();
      emits('update:modelValue', content);
    };
    onMounted(() => {
      quill = new Quill(uEditor.value, {
        theme: 'snow',
        modules: {
          formula: false,
          syntax: false,
          history: {
            delay: 1000,
            userOnly: true
          },
          toolbar: {
            container: props.customToolbar.length ? props.customToolbar : toolbarOptions
          }
        }
      });
      setContents(props.modelValue);
      quill.on('text-change', function () {
        handleContent();
      });
      quill.root.setAttribute('spellcheck', false);
      // 只保留纯文本
      quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
        let ops = [];
        delta.ops.forEach(op => {
          if (op.insert && typeof op.insert === 'string') {
            ops.push({
              insert: op.insert
            });
          }
        });
        delta.ops = ops;
        return delta;
      });
      quill.getModule('toolbar').addHandler('image', uploadImageHandler);
    });
    const uploadImageHandler = () => {
      const input = document.querySelector('#uploadImg');
      input.value = '';
      input.click();
    };
    const uploadImage = async event => {
      const res = await ultraUploadFile({
        params: {
          file: event.target.files[0]
        }
      });
      const index = (quill.getSelection() || {}).index || quill.getLength() - 1;
      quill.insertEmbed(index, 'image', res.url, Quill.sources.USER);
      console.log(quill.setSelection);
      quill.setSelection({
        index: index + 1,
        length: 0
      });
    };
    const getContent = () => {
      return quill.container.firstChild.innerHTML;
    };
    const setContents = val => {
      quill.root.innerHTML = val;
      return quill;
    };
    onBeforeUnmount(() => {
      quill = null;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "u-editor",
        ref_key: "uEditor",
        ref: uEditor
      }, null, 512), _createElementVNode("input", {
        id: "uploadImg",
        type: "file",
        style: {
          "display": "none"
        },
        accept: "image/png, image/jpeg, image/gif",
        onChange: uploadImage
      }, null, 32)]);
    };
  }
});